/**
 * Pre-defined list of flow categories and their sub-flows.
 * Used when creating or classifying flows in the product library.
 *
 * Sources that can be passed to the API:
 *   "screenshot" | "video" | "figma" | "posthog"
 */

export const FLOW_CATEGORIES = [
  {
    name: 'New User Experience',
    flows: [
      'Browsing Tutorial',
      'Creating Account',
      'Onboarding',
    ],
  },
  {
    name: 'Account Management',
    flows: [
      'Editing Profile',
      'Deleting & Deactivating Account',
      'Logging In',
      'Logging Out',
      'Resetting Password',
      'Switching Account',
    ],
  },
  {
    name: 'Entry screen',
    flows: [
      'Home',
      'Dashboard',
      'Feed',
      'Inbox',
      'Library',
      'Landing page',
    ],
  },
  {
    name: 'Commerce & Finance',
    flows: [
      'Adding to Cart & Bag',
      'Booking & Reserving',
      'Canceling Order & Refunding',
      'Canceling Subscription',
      'Listing',
      'Purchasing & Ordering',
      'Redeeming',
      'Subscribing & Upgrading',
      'Transferring Money & Donating',
    ],
  },
  {
    name: 'Social',
    flows: [
      'Banning & Blocking',
      'Calling',
      'Chatting & Sending Messages',
      'Commenting & Replying',
      'Following & Subscribing',
      'Gifting',
      'Giving Feedback',
      'Inviting Teammates & Friends',
      'Joining & Accepting',
      'Leaving',
      'Liking & Upvoting',
      'Muting',
      'Referring Friends',
      'Registering',
      'Reporting',
      'Requesting',
      'Reviewing & Rating',
      'Scheduling',
      'Sharing Content',
    ],
  },
  {
    name: 'Content',
    flows: [
      'Adding & Creating',
      'Archiving',
      'Copying & Duplicating',
      'Deleting & Removing',
      'Drawing',
      'Editing & Updating',
      'Favoriting & Pinning',
      'Filtering & Sorting',
      'Importing & Exporting',
      'Listening to Audio',
      'Logging & Tracking',
      'Marking',
      'Moving',
      'Publishing',
      'Recording Audio & Video',
      'Reordering',
      'Saving to Collection',
      'Searching & Finding',
      'Selecting & Choosing',
      'Starting & Completing',
      'Taking Photos',
      'Uploading & Downloading',
      'Watching Video',
    ],
  },
  {
    name: 'Misc',
    flows: [
      'Changing Language',
      'Connecting & Linking',
      'Enabling & Disabling',
      'Setting Up',
      'Showing & Hiding',
      'Switching to Dark Mode',
      'Switching View',
      'Turning On/Off',
      'Verifying',
    ],
  },
];

